import DOMPurify from 'dompurify';

export function sanitizeHTML(dirty) {
  if (!dirty) {
    return '';
  }

  return DOMPurify.sanitize(String(dirty), {
    USE_PROFILES: { html: true },
    FORBID_TAGS: ['script', 'iframe', 'object'],
    FORBID_ATTR: ['onerror', 'onclick', 'onload']
  });
}
